
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeleteSubRepositoryConfirm',

  props: {
    subRepositoryName: {
      type: String,
      required: true
    },
    deletingSubRepository: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      enteredName: ''
    }
  }
})
